module.exports = __webpack_public_path__ + "static/media/rainy.07aa3f06.svg";